import { useQuery } from "@tanstack/react-query";

import { api } from "utils/axios";
import useUrlParams from "utils/urlParms";

const GET_INSURANCE_APPLICANTS_QUERY = "get-insurance-applicants";

const getInsuranceApplicant = async (params) => {
  try {
    const response = await api.get(`/insuranceApplicant`, { params });
    return response.data;
  } catch (e) {
    console.error(e, "Error fetching insurance applicants");
  }
};

const useGetInsuranceApplicant = () => {
  const { getUrlParams } = useUrlParams();
  const params = getUrlParams();

  return useQuery({
    queryKey: [GET_INSURANCE_APPLICANTS_QUERY, params],
    queryFn: () => getInsuranceApplicant(params),
  });
};

export { useGetInsuranceApplicant, GET_INSURANCE_APPLICANTS_QUERY };
